import { AnnouncementVideoBase } from './AnnouncementVideoBase';
import { createYouTubeHandler } from '../../../MediaController';
import { YouTubeHandler } from '../../../MediaController/Video';
import { toBoolean } from '../../../Utility';
import { AnnouncementWidget } from '../AnnouncementWidget';
import { YoutubeAnnouncementConfiguration } from '../types';
import { Log } from '../../../AuxillaryService/Log';
import type { PlayTimes } from '../PlayTimes';

export class AnnouncementYoutube extends AnnouncementVideoBase<YoutubeAnnouncementConfiguration> {
    protected _playerElementId: string;
    protected _player: YouTubeHandler;

    constructor(
        configuration: YoutubeAnnouncementConfiguration,
        widget: AnnouncementWidget,
        playTimes: PlayTimes
    ) {
        super(configuration, widget, playTimes);

        this._playerElementId = `youtube_${configuration.id}_widget_${widget.id}`;

        if (!configuration.youtubelink || configuration.youtubelink === '') {
            Log.Error(
                `YouTube announcement has invalid link for announcement (id=${this.configuration.id})`
            );
        }

        this._player = createYouTubeHandler({
            youtubeLink: configuration.youtubelink || '',
            muted: toBoolean(widget.config.mute_videos),
            showSubtitles: Boolean(configuration.youtube_enable_cc),
            startTime: configuration.video_start_time,
        });
    }
}
